import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from './confirmation-popup.component';
import { Inject } from '@angular/core';

export type ConfirmationPopupResult = 'Confirmed';

export interface ConfirmationPopupData {
  title?: string;
  message: string;
  // Material icon name shown next to the title, e.g. 'warning'. Omit for the plain dialog style.
  icon?: string;
  cancelText?: string;
  confirmText?: string;
  // Adds the SGL forward arrows after the confirm label (used by primary danger actions).
  confirmArrows?: boolean;
  // Styles the confirm button as a destructive/warning action (Material 'warn' color).
  warn?: boolean;
}

export function openConfirmationDialog(
  matDialog: MatDialog,
  data: ConfirmationPopupData
): MatDialogRef<ConfirmationPopupComponent, ConfirmationPopupResult> {
  return matDialog.open<ConfirmationPopupComponent, ConfirmationPopupData, ConfirmationPopupResult>(
    ConfirmationPopupComponent,
    // panelClass lets styles/confirmation-popup.scss turn this into a bottom sheet on mobile
    // (see that file) — applies everywhere this shared dialog is used (Users/Contacts/Alerts),
    // not just here.
    { data, panelClass: 'confirmation-popup-panel' }
  );
}
